module.exports = __webpack_public_path__ + "static/media/savvy-ipfs-docs.af57cb8e.svg";